<template>
  <div class="stw-boot" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true" />
    <div class="glow" aria-hidden="true" />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
:root {
  --stw-surface-900: var(--p-surface-900, #0b0c0f);
  --stw-surface-800: var(--p-surface-800, #14161a);
  --stw-text: var(--p-text-color, #e5e7eb);
  --stw-primary: var(--p-primary-400, #ab72a5);
}

.stw-boot {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  /* Dark base + accent + translucent veil */
  background:
    radial-gradient(
      1200px 800px at 50% -100px,
      color-mix(in srgb, var(--stw-primary), transparent 92%),
      transparent 60%
    ),
    linear-gradient(180deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
    var(--stw-surface-900);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  color: var(--stw-text);
}

.spinner {
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  border: 4px solid rgba(255, 255, 255, 0.08);
  border-top-color: var(--stw-primary);
  animation: stw-spin 900ms linear infinite;
  box-shadow:
    0 0 1px rgba(0, 0, 0, 0.5),
    inset 0 0 12px rgba(255, 255, 255, 0.02);
}

.glow {
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 9999px;
  background: radial-gradient(
    closest-side,
    color-mix(in srgb, var(--stw-primary), transparent 75%),
    transparent 70%
  );
  filter: blur(8px);
  transform: translateY(72px);
  pointer-events: none;
}

@keyframes stw-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
